import type { IconSvgObject } from './types';

const Navigation01Icon: IconSvgObject = [
  ["path", { d: "M9 7L12 2L15 7L12 6L9 7Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M9 17L12 22L15 17L12 18L9 17Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M2 12L7 9L6 12L7 15L2 12Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M22 12L17 9L18 12L17 15L22 12Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }],
  ["path", { d: "M14.0004 12.0085C14.0004 13.114 13.1049 14.0102 12.0002 14.0102C10.8955 14.0102 10 13.114 10 12.0085C10 10.903 10.8955 10.0068 12.0002 10.0068C13.1049 10.0068 14.0004 10.903 14.0004 12.0085Z", stroke: "currentColor", strokeWidth: "1.5", key: "4" }]
];

export default Navigation01Icon;
